import { VALUATION_MY_HOME } from '../../../constants/experiments';
import { IApplicationState } from '../../../types/redux';
import { isExperimentActive } from '../../../utils/experiments';
import { selectExperiments } from '../experiments';

export const selectIsExperimentGroupNameB = (state: IApplicationState) => {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, VALUATION_MY_HOME, 'B');
};
